import { ROUTES } from "../../constants/routes";
import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SITE } from "../../constants/site";
import { breadcrumbSchema, webPageSchema } from "../../helpers/structured-data";

@Component({
  selector: "app-privacy",
  imports: [RouterLink, Breadcrumb, Navbar, Footer],
  templateUrl: "./privacy.html",
  styleUrl: "./legal.scss"
})
export class Privacy {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  readonly site = SITE;
  readonly updated = "January 2025";

  ngOnInit(): void {
    this.seo.apply({
      title: "Privacy Policy | VerifyDeceased Data Protection",
      description:
        "How VerifyDeceased collects, uses, protects and retains data for deceased consumer verification, plus the privacy choices available to you.",
      path: "/privacy",
      keywords: "VerifyDeceased privacy policy, data privacy, deceased verification privacy",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Privacy Policy", path: "/privacy" }
        ]),
        webPageSchema({
          name: "Privacy Policy",
          description:
            "How VerifyDeceased collects, uses, protects and retains data for deceased consumer verification.",
          path: "/privacy"
        })
      ]
    });
  }
}
